export default __webpack_public_path__ + "static/media/pety-logo-200.cf384d27.jpg";